module.exports = __webpack_public_path__ + "img/cpos-dark.4caa7dd4.webp";